import { render, staticRenderFns } from "./EditPersonalDetails.vue?vue&type=template&id=75efde08&scoped=true"
import script from "./EditPersonalDetails.vue?vue&type=script&lang=js"
export * from "./EditPersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./EditPersonalDetails.vue?vue&type=style&index=0&id=75efde08&prod&scoped=true&lang=css"
import style1 from "./EditPersonalDetails.vue?vue&type=style&index=1&id=75efde08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75efde08",
  null
  
)

export default component.exports